/*
 * File: index.ts
 * Project: rast-app
 * Create Date: Thursday, 12th March 2026
 * Author: Pedro Santos (pedro.santos@vonbraunlabs.com)
 * -----
 * Last Modified: Thursday, 12th March 2026 10:33:52 pm
 * Modified by: Pedro Santos (pedro.santos@vonbraunlabs.com)
 * -----
 * Copyright (c) 2026 CPA Wernher von Braun
 * ----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	---------------------------------------------------------
 */

export * from './app.routes';
